const rankings = [
  { rank: 1, title: '探花精品合集 · 七月特辑', views: '128.6w', tag: 'hot', trend: 'up' },
  { rank: 2, title: '探花在线独家 · 经典回顾系列', views: '96.3w', tag: '', trend: 'up' },
  { rank: 3, title: '最新上架 · 探花精选推荐', views: '82.7w', tag: 'new', trend: 'up' },
  { rank: 4, title: '探花稀有资源 · 珍藏合集', views: '71.5w', tag: 'rare', trend: 'same' },
  { rank: 5, title: '探花高人气 · 周榜热门', views: '65.2w', tag: '', trend: 'down' },
  { rank: 6, title: '新人推荐 · 探花新晋内容', views: '58.9w', tag: 'new', trend: 'up' },
  { rank: 7, title: '探花连载系列 · 持续更新', views: '52.4w', tag: '', trend: 'same' },
];

function RankBadge({ rank }: { rank: number }) {
  if (rank === 1) return <span className="w-7 h-7 rounded-full bg-accent-500 text-white text-xs font-bold flex items-center justify-center flex-shrink-0">{rank}</span>;
  if (rank === 2) return <span className="w-7 h-7 rounded-full bg-primary-500 text-white text-xs font-bold flex items-center justify-center flex-shrink-0">{rank}</span>;
  if (rank === 3) return <span className="w-7 h-7 rounded-full bg-secondary-500 text-white text-xs font-bold flex items-center justify-center flex-shrink-0">{rank}</span>;
  return <span className="w-7 h-7 rounded-full bg-background-300 text-foreground-500 text-xs font-bold flex items-center justify-center flex-shrink-0">{rank}</span>;
}

export default function RankingSection() {
  return (
    <section id="ranking" className="scroll-mt-16 py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
            热门排行
          </h2>
          <div className="max-w-2xl mx-auto space-y-2">
            {rankings.map((item) => (
              <a
                key={item.rank}
                href="#ranking"
                onClick={(e) => e.preventDefault()}
                className="flex items-center gap-4 p-4 bg-background-100 rounded-lg border border-background-200/60 hover:border-primary-300 transition-all duration-200 cursor-pointer group"
              >
                <RankBadge rank={item.rank} />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 transition-colors truncate">
                    {item.title}
                  </p>
                  <p className="text-xs text-foreground-400 mt-0.5">{item.views} 次浏览</p>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                  {item.tag === 'hot' && <span className="px-1.5 py-0.5 text-[10px] font-bold text-accent-600 bg-accent-100 rounded-full">热</span>}
                  {item.tag === 'new' && <span className="px-1.5 py-0.5 text-[10px] font-bold text-secondary-600 bg-secondary-100 rounded-full">新</span>}
                  {item.tag === 'rare' && <span className="px-1.5 py-0.5 text-[10px] font-bold text-primary-600 bg-primary-100 rounded-full">稀有</span>}
                  {item.trend === 'up' && <i className="ri-arrow-up-line text-accent-500 text-sm"></i>}
                  {item.trend === 'down' && <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>}
                  {item.trend === 'same' && <i className="ri-subtract-line text-foreground-400 text-sm"></i>}
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}